import { gql, useMutation } from '@apollo/client';
import { ContactCard } from '../types';
import { getVerifiedContactCardsByProjectIdQuery, verifiedContactCardFragment } from './queries';

export const updateVerifiedContactCardMutation = gql`
  ${verifiedContactCardFragment}
  mutation UpdateVerifiedContactCard($id: Long!, $fields: VerifiedContactCardFieldsInput!) {
    updateVerifiedContactCard(id: $id, fields: $fields) {
      success {
        ...VerifiedContactCardFragment
      }
      failure {
        message
      }
    }
  }
`;

export const createVerifiedContactCardMutation = gql`
  ${verifiedContactCardFragment}
  mutation CreateVerifiedContactCard(
    $displayName: String!
    $smsSenderId: Long!
    $website: String
    $imageUrl: String
    $subheader: String
    $email: String
  ) {
    createVerifiedContactCard(
      displayName: $displayName
      smsSenderId: $smsSenderId
      website: $website
      imageUrl: $imageUrl
      subheader: $subheader
      email: $email
    ) {
      success {
        ...VerifiedContactCardFragment
      }
      failure {
        message
      }
    }
  }
`;

export const deleteVerifiedContactCardMutation = gql`
  mutation DeleteVerifiedContactCard($id: Long!) {
    deleteVerifiedContactCard(id: $id) {
      success
      failure {
        message
      }
    }
  }
`;

export function useUpdateVerifiedContactCard(
  onComplete: (contactCard: ContactCard) => void,
  onError: (message: string) => void,
) {
  const [updateVcc] = useMutation(updateVerifiedContactCardMutation, {
    onCompleted: (response) => {
      const { success, failure } = response.updateVerifiedContactCard;
      if (success) {
        onComplete(success);
      }
      if (failure) {
        onError(failure.message);
      }
    },
    onError: (e) => onError(e.message),
  });

  return updateVcc;
}

export function useCreateVerifiedContactCard(
  onComplete: (contactCard: ContactCard) => void,
  onError: (message: string) => void,
) {
  const [createVcc] = useMutation(createVerifiedContactCardMutation, {
    onCompleted: (response) => {
      const { success, failure } = response.createVerifiedContactCard;
      if (success) {
        onComplete(success);
      }
      if (failure) {
        onError(failure.message);
      }
    },
    onError: (e) => onError(e.message),
    refetchQueries: [{ query: getVerifiedContactCardsByProjectIdQuery }, 'GetContactCards'],
  });

  return createVcc;
}

export function useDeleteVerifiedContactCard(
  onComplete: () => void,
  onError: (message: string) => void,
) {
  const [updateVcc] = useMutation(deleteVerifiedContactCardMutation, {
    onCompleted: (response) => {
      const { success, failure } = response.deleteVerifiedContactCard;
      if (success) {
        onComplete();
      }
      if (failure) {
        onError(failure.message);
      }
    },
    onError: (e) => onError(e.message),
  });

  return updateVcc;
}
